import { useDispatch, useSelector } from "react-redux";
import { MainCameraPosition } from "Domain/Scene/Handler/CameraHandler";
import { setCameraOrientation } from "Domain/Scene/Handler/CameraOrientationHandler";

export const useTools = ({ onEditMode, setOnEditMode }) => {
    const dispatch = useDispatch();
    const { AnimationReducer, ViewportReducer } = useSelector((state) => state);
    const viewerType = ViewportReducer.viewerType;
    const { mainViewerLayer } = ViewportReducer;

    const actions = {
        showAll: { type: "MAINVIEWER_LAYER", payload: "all" },
        showMaxi: { type: "MAINVIEWER_LAYER", payload: "maxi" },
        showMand: { type: "MAINVIEWER_LAYER", payload: "mandi" },
        showNone: { type: "MAINVIEWER_LAYER", payload: "none" },
        mainPosition: { type: "MAINCAMERA_POSITION", payload: {} },
        autoMode: { type: "CAMERA_AUTOMODE", payload: !AnimationReducer.autoRotate },
    };

    const changeCameraPosition = (x, y, z) => {
        MainCameraPosition(x, y, z);
        const isEditionMode = ViewportReducer.mode === "edition";
        const isMaxiOrientation = x === 0 && y === -10 && z === -180;
        const isMandiOrientation = x === 0 && y === -10 && z === 180;

        if (isEditionMode && isMaxiOrientation) {
            setCameraOrientation("maxi");
        } else if (isEditionMode && isMandiOrientation) {
            setCameraOrientation("mandi");
        }
    };

    const dispatchAction = (prop) => {
        switch (prop) {
            case "all":
                dispatch(actions.showAll);
                break;
            case "mandi":
                dispatch(actions.showMand);
                break;
            case "maxi":
                dispatch(actions.showMaxi);
                break;
            case "none":
                dispatch(actions.showNone);
                break;
            default:
                dispatch(actions.showAll);
                break;
        }
    };

    const changeActive = (type) => {
        dispatchAction(type);
    };

    return {
        dispatch,
        AnimationReducer,
        ViewportReducer,
        viewerType,
        mainViewerLayer,
        changeCameraPosition,
        changeActive,
        actions,
    };
};
